import { useQuery } from '@tanstack/react-query';
import api from '../../../lib/api';

export type IntegrationType = {
  integrationId?: string;
  enabled: boolean;
  provider: string;
  type: string;
};

export function useGetTenantIntegrations() {
  return useQuery({
    queryKey: ['getTenantIntegrations'],
    queryFn: async () => {
      const res = await api.get(
        `/api/core/tenant/integrations?include=environment`,
      );
      return res.data.data as IntegrationType[];
    },
  });
}
